import { render, staticRenderFns } from "./principleTable.vue?vue&type=template&id=fdc0996a&"
import script from "./principleTable.vue?vue&type=script&lang=js&"
export * from "./principleTable.vue?vue&type=script&lang=js&"
import style0 from "./principleTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports